import React from "react";
import { ArrowRight } from "lucide-react";
import TopBar from "../../components/TopBar"; // 👈 IMPORT CORRETTO

const CORSI = [
    {
        title: "Corso Alimentaristi",
        subtitle: "HACCP • aggiornamento rapido • attestato",
        img: "/img/corsi/alimentaristi.png",
        href: "/corso-alimentaristi",
    },
    {
        title: "HACCP Base & Avanzato",
        subtitle: "Procedure • registri • checklist pronte",
        img: "/img/corsi/haccp.png",
        href: "/corso-haccp",
    },
    {
        title: "Sicurezza Alimentare per Team",
        subtitle: "Formazione multi-persona • gestione ruoli",
        img: "/img/corsi/team.png",
        href: "/corso-team",
    },
];

export default function RichiediCorso() {
    return (
        <>
            {/* 🔥 TOPBAR */}
            <TopBar />

            <div className="min-h-screen bg-white">
                {/* Header */}
                <div className="max-w-6xl mx-auto px-4 pt-10 pb-6">
                    <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-gray-900">
                        Richiedi un corso
                    </h1>
                    <p className="mt-2 text-gray-600 max-w-2xl">
                        Scegli il percorso più adatto alla tua azienda. Clicca su un corso per aprire
                        la pagina dedicata.
                    </p>
                </div>

                {/* Griglia corsi */}
                <div className="max-w-6xl mx-auto px-4 pb-14">
                    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {CORSI.map((c) => (
                            <button
                                key={c.title}
                                onClick={() => (window.location.href = c.href)}
                                className="group text-left rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition bg-white"
                            >
                                <div className="relative h-44">
                                    <img
                                        src={c.img}
                                        alt={c.title}
                                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.02] transition"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                                    <div className="absolute bottom-3 left-3 right-3">
                                        <div className="text-white font-semibold text-lg">{c.title}</div>
                                        <div className="text-white/85 text-sm">{c.subtitle}</div>
                                    </div>
                                </div>

                                <div className="p-4 flex items-center justify-between">
                                    <span className="text-gray-900 font-medium">Apri corso</span>
                                    <ArrowRight className="w-5 h-5 text-gray-700 group-hover:translate-x-0.5 transition" />
                                </div>
                            </button>
                        ))}
                    </div>

                    {/* Footer piccolo */}
                    <div className="mt-10 rounded-2xl border border-gray-200 p-5 bg-gray-50">
                        <p className="text-gray-700">
                            Vuoi un corso personalizzato per più sedi o più ruoli? Scegli un corso e troverai
                            la pagina con i dettagli e l’accesso.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}